@if (isLoading()) {
  <div class="stripe-card__loading">
    Loading secure payment form...
  </div>
}

@if (stripeError()) {
  <div class="stripe-card__error">
    {{ stripeError() }}
  </div>
}

<div
  class="stripe-card__field"
  [class.stripe-card__field--hidden]="isLoading() || stripeError()"
>
  <span class="stripe-card__field-label">Card Details</span>
  <div #cardMount class="stripe-card__field-element"></div>
  @if (cardError()) {
    <span class="stripe-card__field-error">{{ cardError() }}</span>
  }
</div>
